export default __webpack_public_path__ + "static/media/cardholder.50f0db5c.png";